import React, { useEffect, useState, useContext, useRef, useMemo } from 'react';
import { IonButton, IonSlides, IonGrid, IonTabs, IonTab, IonTabBar, IonTabButton, IonToolbar, IonTitle, IonContent, IonHeader, IonLabel, IonRouterOutlet, IonFooter, IonCard, IonList, IonItem, IonicSlides, IonText, IonIcon, IonPopover, IonModal, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent, IonBadge, IonSearchbar } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonImg } from '@ionic/react';

import {JobDescriptionModal} from '../components/Modal_JobDescription';
import { CreateRequisitionModal } from '../../zInternal_Features/merchant/components/Modal_CreateRequisition';
import { CreateRequisitionModal_Public } from '../../zPublic/components/Modal_CreateRequisition_Public';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import { GPSC_Component } from './Merchant_GeoLocation';
import {CachedImage} from './Component_CachedImage'; // Import CachedImage component

import '../../css/layout.css';

const toDate = (v) => {
  if (!v) return null;
  // try native parse first; fallback to common formats if you need
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d;
};

const normalize = (s) => (s || "").toString().toLowerCase();

export function Home_JobsList (props) 
{

    let authMerchant_objects = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID ] = useState(authMerchant_objects.acctID);
    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);

    let [viewMerchantList_jobBoardServices, setViewMerchantList_jobBoardServices] = useState([]);

    let [noRequisitions, setNoRequisitions] = useState(true);
    let [viewRequisitionsetailData, setViewRequisitionsetailData] = useState([]);

    let [createRequisitionModal, setCeateRequisitionModal] = useState(false);

    let [requisitionID, setRequisitionID] = useState(false);
    let [requisitionName, setRequisitionName] = useState(false);
    let [requisitionResponsibilites, setRequisitionResponsibilites] = useState(false);
    let [requisitionQualifications, setRequisitionQualifications] = useState(false);
    let [requisitionDeadline, setRequisitionDeadline] = useState(false);
    let [companyAcctID, setCompanyAcctID] = useState('');

    let [showJobDescriptionModal, setShowJobDescriptionModal] = useState(false);

    const [search, setSearch] = useState("");
    const [city, setCity] = useState("");             // exact match; tweak to "includes" if you prefer
    const [sortBy, setSortBy] = useState("latest");   // latest | deadlineAsc | deadlineDesc | company | title

  // Build list of available cities for the filter (unique, case-insensitive)
  const cityOptions = useMemo(() => {
    const set = new Set(
      viewRequisitionsetailData
        .map(r => (r.city || "").trim())
        .filter(Boolean)
    );
    return Array.from(set).sort((a,b) => a.localeCompare(b));
  }, [viewRequisitionsetailData]);

  // Derived, filtered, sorted data (never mutate the prop array)
  const jobs = useMemo(() => {
    const q = normalize(search);

    // 1) filter
    const filtered = viewRequisitionsetailData.filter(r => {
      const inCity = city ? normalize(r.city) === normalize(city) : true;
      const inSearch =
        !q ||
        normalize(r.requisitionName).includes(q) ||
        normalize(r.companyName).includes(q) ||
        normalize(r.city).includes(q) ||
        normalize(r.requisitionResponsibilites).includes(q);
      return inCity && inSearch;
    });

    // 2) sort (copy first)
    const arr = filtered.slice();

    arr.sort((a, b) => {
      if (sortBy === "company") {
        return (a.companyName || "").localeCompare(b.companyName || "");
      }
      if (sortBy === "title") {
        return (a.requisitionName || "").localeCompare(b.requisitionName || "");
      }
      // deadlines: newest/oldest first
      const da = toDate(a.requisitionDeadline);
      const db = toDate(b.requisitionDeadline);

      if (sortBy === "deadlineAsc") {
        if (da && db) return da - db;
        if (da) return -1;
        if (db) return 1;
        return 0;
      }
      if (sortBy === "deadlineDesc") {
        if (da && db) return db - da;
        if (db) return -1;
        if (da) return 1;
        return 0;
      }

      // "latest": if you have a createdAt, prefer that; else fallback to ID or deadlineDesc
      // Example fallback to deadlineDesc:
      if (db && da) return db - da;
      if (db) return -1;
      if (da) return 1;
      return 0;
    });

    return arr;
  }, [viewRequisitionsetailData, search, city, sortBy]);

    useEffect(() => {

            let formData = new FormData();
            formData.append('Tracker', '0002_jobBoard');
            //formData.append('user', acctID);
            //formData.append('xCheckInRoomID', props.data.requisitionID);
        
        
            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
        

            //alert(baseURL);

            
            let newBaseURL = 'https://ghanaverified.com';
            if(baseURL == 'https://bluefinhoteltest.com/' || baseURL == 'https://bluefinhoteltest.com/overviewTab')
            {
                newBaseURL = 'https://ghanaverifiedtest.com'
            }

            //alert(baseURL);
            //fetch(newBaseURL+'/public_request', requestOptions)
            fetch(baseURL+'merchants_argsApp/', requestOptions)
            .then(res => res.text())
            .then(res => {

                //alert(res);
        
                let rows = res.toString().split('~~~');
                //let cols;
                //alert(rows);
                //alert(rows.length);

                if(rows.length > 0)
                {
                    setNoRequisitions(false);
                }

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                                                   // alert("Splitting Columns 2");

                    //let cols_spit = rows[rownum].split('~~~');
                    let cols = rows[rownum].split('|');
                   // let cols_1 = cols_spit[1].split('|');

                    //alert("Splitting Columns 3");
                    //alert(cols_spit);
                    //alert(cols);
                    //alert(cols[9]);


                    setViewMerchantList_jobBoardServices((prevViewMerchantList_hotels) => {
                        return prevViewMerchantList_hotels.concat({
                            companyAcctID: cols[0],
                            companyName: cols[1],
                            companyAddressNumber: cols[2],
                            streetName: cols[3],
                            city: cols[4],
                            cityDistrict: cols[5],
                            companyPhoneNumber: cols[6],
                            companyEmail: cols[7],
                            companyImage: cols[8],
                            companySchema: cols[9],
                            customerRating: cols[11],
                            latitude: cols[12],
                            longitude: cols[13],
                            mtnCompanyPhoneNumber: cols[14]
                        })

                    });
                            //alert('1');
                            //alert(cols[9]);
                            //alert(cols[10]);

                            let row_jobList = [];

                            if (cols[10] && cols[10].trim() !== "") {
                            row_jobList = cols[10].split('%');
                            }                            
                            //alert('2');
                            //alert(row_jobList);
                            //alert(row_jobList.length);

                        for (let rownum2 = 0; rownum2 < row_jobList.length - 1; ++rownum2)
                        {
                            let cols2 = row_jobList[rownum2].split('&');
                            //alert('3');
                            //alert(cols2);

                            setViewRequisitionsetailData((prevViewRequisitionsetailData) => {
                                return prevViewRequisitionsetailData.concat({
                                    companyAcctID: cols[0],
                                    companyName: cols[1],
                                    city: cols[4],
                                    requisitionID: cols2[0],
                                    companyRole: cols2[1],
                                    requisitionName: cols2[2],
                                    requisitionResponsibilites: cols2[3],
                                    requisitionQualifications: cols2[4],
                                    requisitionDeadline: cols2[5],
                                    dateCreated: cols2[6],
                                })

                            });
                
                        } 

        
                } 
            })
    }, []);

    function viewJobDescriptionModalHandler(event)
    {
        setRequisitionID(event[1]);
        setRequisitionName(event[2]);
        setRequisitionResponsibilites(event[3]);
        setRequisitionQualifications(event[4]);
        setRequisitionDeadline(event[5]);
        setCompanyAcctID(event[6]);

        setShowJobDescriptionModal(event[0]);
    }

    //alert("in Componet home JobList");
    //alert(props.data.status);


    return (
    <React.Fragment>
        {noRequisitions === true ? (
            <div className="dot-loader">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
            </div>
        ) : (
        <IonContent className='grid_content_jobBoardList'>

                  {/* Simple filter bar */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, padding: 12 }}>
                <input
                value={search}
                onInput={(e) => setSearch(e.target.value || "")}
                placeholder="Search"
                />
                <select value={city} placeholder="City" interface="popover" onChange={(e) => setCity(e.target.value)}>
                <option value="">All Cities</option>
                {cityOptions.map(c => (
                    <option key={c} value={c}>{c}</option>
                ))}
                </select>
                <select value={sortBy} placeholder="Sort" interface="popover" onChange={(e) => setSortBy(e.target.value)}>
                    <option value="latest">Latest</option>
                    <option value="deadlineAsc">Deadline ↑</option>
                    <option value="deadlineDesc">Deadline ↓</option>
                    <option value="company">Company A–Z</option>
                    <option value="title">Title A–Z</option>
                </select>
            </div>
            <IonGrid>
                    {jobs.map((detailData) =>   {
                            return (

                                <IonRow>
                                    <IonCol>
                                        <IonCard className="job-card">
                                            <IonCardHeader>
                                                <IonCardTitle className='job-card-title'>{detailData.requisitionName}</IonCardTitle>
                                                <IonCardSubtitle className='job-card-subtitle'>
                                                {detailData.companyName} • {detailData.city}
                                                </IonCardSubtitle>
                                            </IonCardHeader>

                                            <IonCardContent>
                                                <p className="responsibilities-preview" style={{ marginBottom: "8px" }}>{detailData.requisitionResponsibilites}</p>
                                                <IonBadge color="tertiary">{detailData.requisitionID}</IonBadge>
                                                <div className="ion-text-end" style={{ marginTop: "10px" }}>
                                                <IonButton fill="outline" color="success" size="small" onClick={() => viewJobDescriptionModalHandler([true, detailData.requisitionID, detailData.requisitionName, detailData.requisitionResponsibilites, detailData.requisitionQualifications, detailData.requisitionDeadline, detailData.companyAcctID])}> View </IonButton>
                                                </div>
                                            </IonCardContent>
                                        </IonCard>
                                    </IonCol>
                                </IonRow>
                            )
                        }
                    )}
                </IonGrid>
        </IonContent>
        )}
        {showJobDescriptionModal == true && 
                <JobDescriptionModal openModal={ showJobDescriptionModal } closeModal={() => setShowJobDescriptionModal(false)} data={{
                    requisitionID: requisitionID, 
                    requisitionName: requisitionName,
                    requisitionResponsibilites: requisitionResponsibilites,
                    requisitionQualifications: requisitionQualifications,
                    requisitionDeadline: requisitionDeadline,
                    companyAcctID: companyAcctID, 
                                        }}></JobDescriptionModal>
        }

        {(createRequisitionModal  == true && acctID == null) && <CreateRequisitionModal_Public openModal= { createRequisitionModal } closeModal={() => setCeateRequisitionModal(false)}></CreateRequisitionModal_Public>}
        {(createRequisitionModal  == true && acctID != null) && <CreateRequisitionModal openModal= { createRequisitionModal } closeModal={() => setCeateRequisitionModal(false)}></CreateRequisitionModal>}

    </React.Fragment>
    )
}
